module.exports = __webpack_public_path__ + "static/media/redo-alt.251ab951.svg";